import { useState } from "react";
import "./Enquiry.css";

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    parentName: "",
    studentClass: "",
    email: "",
    mobile: "",
    query: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://vdprasad-backend.onrender.com/send-enquiry", {  
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      

      const data = await response.json();
      if (response.ok) {
        alert("Enquiry submitted successfully!");
        setFormData({
          studentName: "",
          parentName: "",
          studentClass: "",
          email: "",
          mobile: "",
          query: "",
        });
      } else {
        alert("Failed to send enquiry. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="enquiry-container">
      <div className="enquiry-content">
        <h1 className="enquiry-title">ADMISSIONS ENQUIRY</h1>
        <form className="enquiry-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="studentName"
              placeholder="Student Name"
              value={formData.studentName}
              onChange={handleChange}
              required
            />
            <input
              type="number"
              name="studentClass"
              placeholder="Class"
              value={formData.studentClass}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="text"
              name="parentName"
              placeholder="Parent Name"
              value={formData.parentName}
              onChange={handleChange}
              required
            />
            <input
              type="number"
              name="mobile"
              placeholder="Mobile No."
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="query"
            placeholder="Type your Query"
            value={formData.query}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm;
